export default __webpack_public_path__ + "static/dacha-languages-3-5e5840ce6e5b926b9d08c447c9f3d960.png";